import { call, put, takeEvery } from "redux-saga/effects";
import { AnyAction } from "redux";
import { setIsPhrasesLoading } from "./actions";
import apis from "../../../../../../app/apis";
import { googleTagManagerDataLayer } from "../../../../../../app/duck/utils";
import actionTypes, { setIsShowSerpInsightsLoader, setPhraseContent, setSerpInsightsContent } from "../../../../ducks/actions";
import { RecommendationConst } from "./const";
import { getContext } from "../../../../../../app/duck/context-container";

// tslint:disable-next-line:typedef
function* fetchPhraseContent(action: AnyAction) {
    yield put(setIsPhrasesLoading(true));
    const { keywords, searchUrl, locale } = action.payload;
    const phraseApiResponse = yield call(apis.fetchPhraseContent, { keywords, searchUrl, locale });
    if (phraseApiResponse.status === 200) {
        yield put(setIsPhrasesLoading(false));
        const phraseContent = phraseApiResponse.data.phrases;
        yield put(setPhraseContent({ phraseContent, editorContent: action.payload.editorContent }));
    } else {
        yield put(setPhraseContent({ phraseContent: undefined, editorContent: action.payload.editorContent }));
        yield put(setIsPhrasesLoading(false));
        googleTagManagerDataLayer("Recommendation Load Error", [], { recomm_tab: RecommendationConst.PHRASES_TO_USE_LABEL });
    }
}

// tslint:disable-next-line:typedef
export function* watchForFetchPhraseContent() {
    yield takeEvery(actionTypes.CALL_TO_FETCH_PHRASE_CONTENT, fetchPhraseContent);
}

// tslint:disable-next-line:typedef
function* fetchSerpInsightsContent(action: AnyAction) {
    const { tenantCode } = getContext();
    const parser = {
        tenantCode: tenantCode as string
    };
    const { keywords, locale } = action.payload;
    const serpInsightsApiResponse = yield call(apis.fetchSerpInsightsContent, { keywords, locale }, parser);
    if (serpInsightsApiResponse.status === 200) {
        const serpInsightsContent = serpInsightsApiResponse.data;
        yield put(setSerpInsightsContent(serpInsightsContent));
        yield put(setIsShowSerpInsightsLoader(false));
    } else {
        yield put(setSerpInsightsContent(undefined));
        yield put(setIsShowSerpInsightsLoader(false));
    }
}

// tslint:disable-next-line:typedef
export function* watchForFetchSerpInsightsContent() {
    yield takeEvery(actionTypes.CALL_TO_FETCH_SERP_INSIGHTS, fetchSerpInsightsContent);
}
